export const OlympiadStatusKind = {
  registered: 'registered',
  ongoing: 'ongoing',
  upcoming: 'upcoming',
  finished: 'finished',
  unknown: 'unknown',
} as const
export type OlympiadStatusKind = (typeof OlympiadStatusKind)[keyof typeof OlympiadStatusKind]

/**
 * Свободная строка статуса с бэка → устойчивый вид.
 *
 * Факт регистрации сюда больше не входит: в макете он живёт отдельным бейджем
 * рядом со статусом, а не вместо него, — «Вы зарегистрированы» и «Идёт» стоят
 * на карточке вдвоём.
 *
 * ⚠ `status` бэк НЕ переводит: проверено на staging 2026-08-05 запросами с
 * `Accept-Language: en` и `kk` — соседнее поле `registration_status` менялось
 * («Registration is close» / «Тіркелу жабық»), а `status` оставался
 * «Завершена». Английские подстроки ниже — на случай, если это изменят;
 * казахских нет намеренно, добавлять их вслепую нечего (B14).
 */
export function resolveOlympiadStatusKind(status: string): OlympiadStatusKind {
  const s = status.toLowerCase()
  if (s.includes('идет') || s.includes('ongoing') || s.includes('active'))
    return OlympiadStatusKind.ongoing
  if (
    s.includes('предстоя') ||
    s.includes('upcoming') ||
    s.includes('registration_open') ||
    s.includes('открыта')
  )
    return OlympiadStatusKind.upcoming
  if (s.includes('завершен') || s.includes('finished') || s.includes('past'))
    return OlympiadStatusKind.finished
  return OlympiadStatusKind.unknown
}

/** Личный итог участника по олимпиаде. Важнее «Завершено», пока олимпиада не
 *  закончилась: дисквалификация и отмена — про самого участника. Отмена после
 *  конца олимпиады бейджем не показывается (карточка пишет «Завершено»);
 *  дисквалификация остаётся. */
export const OlympiadParticipation = {
  disqualified: 'disqualified',
  cancelled: 'cancelled',
} as const
export type OlympiadParticipation =
  (typeof OlympiadParticipation)[keyof typeof OlympiadParticipation]
